import { useEffect, useState } from 'react';
import axios from 'axios';
import { Languages } from '../../constants';
import { useApplicationParams, useLanguage } from '../../context';

export const useAddressDetails = () => {
  const [addressDetails, setAddressDetails] = useState({
    id: null,
    email: '',
    name: '',
    phone: '',
    address: '',
    city: '',
    countryId: '',
    country: '',
  });

  const { appVersion, platform, deviceId, userToken, isWeb } = useApplicationParams();
  const { language } = useLanguage();

  useEffect(() => {
    const cancelToken = axios.CancelToken.source();

    const getAddressDetails = async () => {
      if (isWeb) {
        const storedAddressDetails = localStorage.getItem('address_details');

        if (storedAddressDetails) {
          setAddressDetails(JSON.parse(storedAddressDetails));
        }
      } else {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/shopv2/addresses/get`,
            {
              headers: {
                'Content-Type': 'application/json',
                'x-api-version': appVersion || '4.11.1',
                'x-api-key': process.env.REACT_APP_API_KEY,
                'x-api-os': platform || 'android',
                'x-user-lang': language || Languages.English,
                'x-api-device-id': deviceId || 'CBC64810-FF0C-4008-9558-A999C18085E7',
                authorization: userToken || '',
              },
              cancelToken: cancelToken.token,
            },
          );

          const addressData = response.data?.data;

          if (addressData && addressData?.length > 0) {
            const lastSavedAddress = addressData[addressData.length - 1];

            setAddressDetails({
              id: lastSavedAddress.id || '',
              phone: lastSavedAddress.phone || '',
              email: lastSavedAddress.email || '',
              name: lastSavedAddress.fullName || '',
              address: lastSavedAddress.address || '',
              city: lastSavedAddress.city || '',
              countryId: `${lastSavedAddress.countryId}` || '1',
              country: lastSavedAddress.country.name_en || 'UAE',
            });
          }
        } catch (error) {
          console.error(`Error get address details`);
        }
      }
    };

    getAddressDetails();

    return () => {
      cancelToken.cancel();
    };
  }, [language]);

  return { addressDetails, setAddressDetails };
};
